import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { getCheckIfSenderEmailUsedApi } from '../api/mailing-settings-sender-emails-api';
import { SenderEmailAddressId } from '../types/sender-email-address-interface';
export function useCheckIfSenderEmailUsed() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    const checkIfSenderEmailUsed = id => fetcher(getCheckIfSenderEmailUsedApi(id));
    t1 = {
      checkIfSenderEmailUsed
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}